import {
  Button,
  CheckIcon,
  PageTitle,
  HeroLogo,
  ResendVerifyEmailButton,
  ResultContainer,
} from '../../components';
import { useNavigate } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';

export const UserRegisterSuccessResult = ({ data }) => {
  const navigate = useNavigate();

  return (
    <ResultContainer>
      <HeroLogo />
      <Stack gap="20px" alignItems="center">
        <Stack alignItems="center">
          <PageTitle>注册成功</PageTitle>
          <Typography
            color="textSecondary"
            fontSize={14}
          >{`您的账号：${data?.email}`}</Typography>
        </Stack>
        <CheckIcon color="#1AB260" size="100px" />
        <Stack direction="row" gap="20px">
          <ResendVerifyEmailButton />
          <Button variant="secondary" onClick={() => navigate('/')}>
            返回首页
          </Button>
        </Stack>
      </Stack>
    </ResultContainer>
  );
};
